export default __webpack_public_path__ + "static/tb_logo-7588230e956564a70a6a7150126e71af.png";